/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import * as React from 'react';
import MenuList from './MenuList';
import AlertDialog from './Message';

interface Props {
    selectedColumns: any;
    exportList: any;
    handleExport: Function;
    totalCount: any;
    isSearchApplied?: any;
    getTotalCountOnExport: Function;
    selectTitle: any;
    isDisabled: any;
}

class Export extends React.Component<Props, any>{
    state = {
        alertOpen: false,
        dialogContent: '',
        selectedItem: 0
    };
    handleExportClick = async (value: any) => {
        if (this.props.totalCount > 5000) {
            this.enableDialog(value);
        }
        else {
            if (this.props.isSearchApplied) {
                const totalCount = await this.props.getTotalCountOnExport();
                if (totalCount > 5000) {
                    this.enableDialog(value);
                }
                else if (totalCount !== 0) {
                    this.props.handleExport(value, this.props.selectedColumns);
                }
            }
            else {
                this.props.handleExport(value, this.props.selectedColumns);
            }
        }
    };
    handleAlertOk = () => {
        this.handleAlertClose();
        this.props.handleExport(this.state.selectedItem, this.props.selectedColumns);
    };
    handleAlertClose = () => {
        this.setState({
            alertOpen: false
        });
    };

    enableDialog = (value: any) => {
        this.setState({
            alertOpen: true,
            dialogContent: 'This operation may take longer than expected. Do you like to continue ?',
            selectedItem: value
        });
    };
    render() {
        const { selectedColumns, exportList, selectTitle, isDisabled } = this.props;
        const dialogTitle = 'Export Confirmation';
        return (
            <div>
                <MenuList isDisabled={((selectedColumns !== undefined && selectedColumns.length === 0) && !isDisabled) || !navigator.onLine ? true : false}
                    listItems={exportList} onClick={this.handleExportClick} selectTitle={selectTitle} />
                <AlertDialog dialogContent={this.state.dialogContent} dialogTitle={dialogTitle}
                    handleClose={this.handleAlertClose} open={this.state.alertOpen} handleOk={this.handleAlertOk} />
            </div>
        );
    }
}
export default Export;
